<div class="quiz-container">
  @if (loading) {
    <div class="loading-container">
      <mat-spinner diameter="40"></mat-spinner>
    </div>
  }

  @if (!loading && !quiz) {
    <div class="empty">No quiz has been defined for this module yet.</div>
  }

  @if (!loading && quiz) {
    <div class="quiz-header">
      <p class="passing-note">Passing score: {{ quiz.passingScore }}%</p>
    </div>

    @if (result) {
      <div class="result-card" [class.result-passed]="result.passed" [class.result-failed]="!result.passed">
        <div class="result-score">{{ result.score }}%</div>
        <div class="result-label">{{ result.passed ? 'Passed' : 'Not Passed' }}</div>
        @if (hasFreeTextAnswers()) {
          <p class="review-note">Some answers require instructor review and were not counted in your score.</p>
        }
        <button mat-stroked-button (click)="retake()" class="retake-btn">Retake Quiz</button>
      </div>
    }

    <form [formGroup]="quizForm">
      @for (q of quiz.questions; track q._id; let qi = $index) {
        <mat-card class="question-card" [class.question-unanswered]="unansweredIndices.has(qi)">
          <mat-card-content>
            <p class="question-prompt">
              <strong>{{ qi + 1 }}.</strong> {{ q.prompt }}
              @if (q.type === 'multi_select') {
                <span class="type-hint">(Select all that apply)</span>
              }
            </p>

            @if (q.type === 'multiple_choice' || q.type === 'true_false') {
              <mat-radio-group [formControlName]="q._id" class="radio-group">
                @for (opt of q.options; track opt._id; let i = $index) {
                  <mat-radio-button [value]="i" class="radio-option">
                    {{ opt.text }}
                  </mat-radio-button>
                }
              </mat-radio-group>
            }

            @if (q.type === 'multi_select') {
              <div class="checkbox-group" [formArrayName]="q._id">
                @for (opt of q.options; track opt._id; let i = $index) {
                  <mat-checkbox [formControl]="getCheckboxControl(q._id, i)" class="checkbox-option">
                    {{ opt.text }}
                  </mat-checkbox>
                }
              </div>
            }

            @if (q.type === 'free_text') {
              <mat-form-field appearance="fill" style="width: 100%">
                <mat-label>Your answer</mat-label>
                <textarea matInput [formControlName]="q._id" rows="4"></textarea>
              </mat-form-field>
            }

            @if (unansweredIndices.has(qi) && !result) {
              <p class="unanswered-hint">Please answer this question before submitting.</p>
            }

            @if (result) {
              @let qr = getQuestionResult(q);
              @if (qr) {
                <div class="answer-feedback"
                     [class.feedback-correct]="qr.correct === true"
                     [class.feedback-incorrect]="qr.correct === false"
                     [class.feedback-review]="qr.requiresReview">
                  @if (qr.correct === true) { ✓ Correct }
                  @if (qr.correct === false) { ✗ Incorrect }
                  @if (qr.requiresReview) { Pending instructor review }
                </div>
              }
            }
          </mat-card-content>
        </mat-card>
      }
    </form>

    @if (!result) {
      @if (unansweredIndices.size > 0) {
        <div class="unanswered-warning">
          Please answer all questions before submitting.
          Unanswered: {{ unansweredLabel }}
        </div>
      }
      <div class="submit-row">
        <button mat-raised-button color="primary" (click)="submit()" [disabled]="submitting">
          @if (submitting) { Submitting... }
          @else { Submit Quiz }
        </button>
      </div>
    }
  }
</div>
